import { css } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { ServiceIcon } from '@zapier/design-system-patterns';
import { mediaQueries } from '@zapier/identity-utils';

import { ZapTemplate } from '../useZapTemplate';
import { FeatureItem, FeatureItemList } from '../FeatureItem';

type Props = {
  zapTemplate: ZapTemplate;
};

const rootStyle = css`
  display: grid;
  grid-gap: 30px;
`;

const serviceIconStyle = css`
  display: none;

  ${mediaQueries.tablet} {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 20px;
    justify-content: flex-start;
  }
`;

const titleStyle = css`
  ${Typography.paragraph3}
  color: ${Colors.neutral800};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.tablet} {
    ${Typography.pageHeader9}
    margin-bottom: 0;
    text-align: left;
  }
`;

export function ZapTemplatePromo({ zapTemplate }: Props) {
  const isTwoService =
    zapTemplate.tailService &&
    zapTemplate.tailService.id !== zapTemplate.headService.id;

  return (
    <div css={rootStyle}>
      <div css={serviceIconStyle}>
        <ServiceIcon
          hasShadow={true}
          serviceName={zapTemplate.headService.id}
          src={zapTemplate.headService.image}
          size={80}
        />
        {isTwoService && (
          <ServiceIcon
            hasShadow={true}
            // @ts-ignore we ensure tailService can't be null
            serviceName={zapTemplate.tailService.id}
            // @ts-ignore we ensure tailService can't be null
            src={zapTemplate.tailService.image}
            size={80}
          />
        )}
      </div>
      {zapTemplate?.title && <h3 css={titleStyle}>{zapTemplate?.title}</h3>}
      <FeatureItemList>
        <FeatureItem key="1">Easy setup, no coding required</FeatureItem>
        <FeatureItem key="2">Free forever for core features</FeatureItem>
        <FeatureItem key="3">
          14-day trial of premium features & apps
        </FeatureItem>
      </FeatureItemList>
    </div>
  );
}
